const MediaIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M9.31885 22H15.3188C20.3188 22 22.3188 20 22.3188 15V9C22.3188 4 20.3188 2 15.3188 2H9.31885C4.31885 2 2.31885 4 2.31885 9V15C2.31885 20 4.31885 22 9.31885 22Z"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.31885 10C10.4234 10 11.3188 9.10457 11.3188 8C11.3188 6.89543 10.4234 6 9.31885 6C8.21428 6 7.31885 6.89543 7.31885 8C7.31885 9.10457 8.21428 10 9.31885 10Z"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.98877 18.9496L7.91877 15.6396C8.70877 15.1096 9.84877 15.1696 10.5588 15.7796L10.8888 16.0696C11.6688 16.7396 12.9288 16.7396 13.7088 16.0696L17.8688 12.4996C18.6488 11.8296 19.9088 11.8296 20.6888 12.4996L22.3188 13.8996"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default MediaIcon;
